/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const TestPlanTypes = {
  // GET
  GET_TEST_PLAN: asyncActionType('GET_TEST_PLAN'),
  GET_TEST_PLAN_OPTIONS: asyncActionType('GET_TEST_PLAN_OPTIONS'),
  GET_TEST_PLAN_PRODUCTS: asyncActionType('GET_TEST_PLAN_PRODUCTS'),

  // CREATE
  CREATE_TEST_PLAN_PRODUCT_REQUEST: asyncActionType('CREATE_TEST_PLAN_PRODUCT_REQUEST'),
  CREATE_TEST_PLAN_SUBSCRIPTION: asyncActionType('CREATE_TEST_PLAN_SUBSCRIPTION'),

  // DOWNLOAD
  DOWNLOAD_TEST_PLAN_PDF: asyncActionType('DOWNLOAD_TEST_PLAN_PDF'),
};
